import styled from 'styled-components'

import colors from 'styles/colors'

export const StyledHeading = styled.h2`
    color: ${colors.blueDark};
    font-size: 2.4rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 2.9rem;
    margin: 1rem 0rem;
    text-transform: capitalize;
`

export const StyledBody = styled.div`
    background: ${colors.white89deg};
    border-radius: 2rem;
    box-shadow: ${colors.shadowBlack};
    padding: 2rem;
`

export const StyledSelectSubject = styled.button`
    align-items: center;
    background-color: ${colors.white};
    border: 0.1rem solid rgba(38, 42, 51, 0.2);
    border-radius: 1.5rem;
    color: ${colors.blueDark};
    cursor: pointer;
    display: flex;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.7rem;
    letter-spacing: 0.02em;
    height: 5rem;
    margin-bottom: 2rem;
    padding: 1rem 2rem;
    width: 100%;
`

export const StyledSelectSubjectIconContainer = styled.span`
    align-items: center;
    background: ${colors.black157deg};
    border-radius: 1rem;
    display: flex;
    height: 3rem;
    justify-content: center;
    margin-right: 1rem;
    width: 3rem;
`

export const StyledBodyBottomLine = styled.div`
    background: ${colors.platinumGray};
    height: 0.1rem;
    margin: 2rem 0;
`

export const StyledBodyBottomButtons = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
`

export const StyledTextarea = styled.textarea`
    background-color: ${colors.white};
    border: 0.1rem solid rgba(38, 42, 51, 0.2);
    border-radius: 1.5rem;
    color: ${colors.blueDark};
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 1.7rem;
    letter-spacing: 0.02em;
    margin-bottom: 2rem;
    height: 16rem;
    outline: none;
    padding: 1rem 2rem;
    resize: none;
    width: 100%;
`

export const StyledAttachmentListItem = styled.li`
    align-items: center;
    display: flex;
    list-style: none;
    position: relative;
    svg {
        margin-right: 1.5rem;
    }
    &:not(:last-of-type) {
        margin-bottom: 0.5rem;
    }
`

export const StyledAttachmentType = styled.span`
    color: #26b99a;
    display: block;
    left: 0.7rem;
    position: absolute;
    text-transform: uppercase;
    top: 1.6rem;
`

export const StyledAttachmentDetails = styled.div`
    margin-right: 1.5rem;
`

export const StyledAttachmentName = styled.span`
    display: block;
    font-weight: 600;
`

export const StyledAttachmentSize = styled.span`
    color: ${colors.silverGray};
    display: block;
`

export const StyledAttachmentDeleteButton = styled.button`
    background-color: #f2f6f9;
    border-radius: 50%;
    height: 2rem;
    width: 2rem;
    img {
        height: 1rem;
        width: 1rem;
    }
`

export const StyledAttachmentDeleteButtonIcon = styled.img`
    height: 1rem;
    width: 1rem;
`
